jQuery("#send_email").click(function(event){
  event.preventDefault();
  var home_page_contact_us = 'Name : '+jQuery("input[name='contactFormName']").val()+'</br>';
  home_page_contact_us = home_page_contact_us+'<br>Email : '+jQuery("input[name='contactFormEmail']").val();
  home_page_contact_us = home_page_contact_us+'<br>Phone : '+jQuery("input[name='contactFormTelephone']").val();
  home_page_contact_us = home_page_contact_us+'<br>Messgae : '+jQuery("textarea[name='contactFormMessage']").val();
	Email.send(jQuery("input[name='contactFormEmail']").val(),
		"SocialPowerBox@gmail.com",
		"Socialpowerbox - Contact us",
		home_page_contact_us,
		"smtp.mailgun.org",
		"postmaster@quadrant.technology",
		"93cacc03c948a05fdbcfcacab7ab0343");
	console.log("sent");
  setTimeout(function(){ 
    showSuccessMessage(); 
  }, 1000);
  hideSuccessMessgae();
});

//FOOTER SUBSCRIPTION
jQuery("#Subscribe").click(function(){
  event.preventDefault();
  var home_page_contact_us = 'Email : '+jQuery("input[name='subscriptionEmail']").val()+'</br>';
	Email.send(jQuery("input[name='subscriptionEmail']").val(),
		"SocialPowerBox@gmail.com",
		"Socialpowerbox - footer - subscribe",
		home_page_contact_us,
		"smtp.mailgun.org",
		"postmaster@quadrant.technology",
		"93cacc03c948a05fdbcfcacab7ab0343");
  	setTimeout(function(){ 
      jQuery(".footer_success_message").show(); 
      jQuery("form.customer-subscribe").hide();
      setCookie('customer-subscribe','true',1);
    }, 1000);
    setTimeout(function(){ 
      jQuery(".footer_success_message").hide(); 
    }, 6000);
});

//REVIEW PAGE FORM
jQuery("#clientFormSubmit").click(function(){
  event.preventDefault();
  var home_page_contact_us = 'Name : '+jQuery("input[name='clientName']").val();
  home_page_contact_us = home_page_contact_us+'<br>Email : '+jQuery("input[name='clientEmail']").val();
  home_page_contact_us = home_page_contact_us+'<br>Message : '+jQuery("textarea[name='clientMessage']").val();
  home_page_contact_us = home_page_contact_us+'<br>Star : '+jQuery("select[name='rating']").val();
	Email.send(jQuery("input[name='clientEmail']").val(),
		"SocialPowerBox@gmail.com",
		"socialpower - support - contact us",
		home_page_contact_us,
		"smtp.mailgun.org",
		"postmaster@quadrant.technology",
		"93cacc03c948a05fdbcfcacab7ab0343");
  	setTimeout(function(){ 
      showSuccessMessage('clientFormSubmit'); 
    }, 1000);
  	hideSuccessMessgae();
});

//SUPPORT PAGE FORM
jQuery("#supportSubscription").click(function(){
  event.preventDefault();
  var home_page_contact_us = 'Name : '+jQuery("input[name='clientName']").val();
  home_page_contact_us = home_page_contact_us+'<br>Email : '+jQuery("input[name='clientEmail']").val();
  home_page_contact_us = home_page_contact_us+'<br>Message : '+jQuery("textarea[name='clientMessage']").val();
	Email.send(jQuery("input[name='clientEmail']").val(),
		"SocialPowerBox@gmail.com",
		"socialpower - support - contact us",
		home_page_contact_us,
		"smtp.mailgun.org",
		"postmaster@quadrant.technology",
		"93cacc03c948a05fdbcfcacab7ab0343");
  	setTimeout(function(){ 
      showSuccessMessage('supportSubscription'); 
    }, 1000);
  	hideSuccessMessgae();
});

//HOME PAGE FORM
jQuery("#homePageSubscription").click(function(){
  event.preventDefault();
  var home_page_contact_us = 'Name : '+jQuery("input[name='homePageSubscriptionName']").val();
  home_page_contact_us = home_page_contact_us+'<br>Email : '+jQuery("input[name='homePageSubscriptionEmail']").val();
	Email.send(jQuery("input[name='homePageSubscriptionEmail']").val(),
		"SocialPowerBox@gmail.com",
		"Socialpowerbox - home page - get more information",
		home_page_contact_us,
		"smtp.mailgun.org",
		"postmaster@quadrant.technology",
		"93cacc03c948a05fdbcfcacab7ab0343");
  	setTimeout(function(){ 
      showSuccessMessage('homePageSubscriptionName'); 
    }, 1000);
  	hideSuccessMessgae();
});

//START PAGE FORM
jQuery("#pageStartSubscription").click(function(){
  event.preventDefault();
  var home_page_contact_us = 'Name : '+jQuery("input[name='pageStartSubscriptionName']").val();
  home_page_contact_us = home_page_contact_us+'<br>Email : '+jQuery("input[name='pageStartSubscriptionEmail']").val();
	Email.send(jQuery("input[name='pageStartSubscriptionEmail']").val(),
		"SocialPowerBox@gmail.com",
		"Socialmodel - Get in Touch",
		home_page_contact_us,
		"smtp.mailgun.org",
		"postmaster@quadrant.technology",
		"93cacc03c948a05fdbcfcacab7ab0343");
  	setTimeout(function(){ 
      showSuccessMessage('subscriptionEmail'); 
    }, 1000);
  	hideSuccessMessgae();
});

function showSuccessMessage(purpose)
{
  jQuery(".success_message").show();
  if(purpose == 'homePageSubscriptionName')
  {
    jQuery("#mc_embed_signup_scroll").hide();
    setCookie('homePageSubscriptionName','true',1);
  }
  if(purpose == 'customer-subscribe')
  {
    jQuery(".customer-subscribe").hide();
  }
  if(purpose == 'clientFormSubmit')
  {
    jQuery("form.contact-form").hide();
    setCookie('clientFormSubmit','true',1);
  }
  if(purpose == 'supportSubscription')
  {
    jQuery("form.contact-form").hide();
    setCookie('supportSubscription','true',1);
  }
}

function hideSuccessMessgae()
{
  setTimeout(function(){ 
    jQuery(".success_message").hide(); 
  }, 6000);
}

//CHECK COOKIE TO SHOW FORM
checkCookie('homePageSubscriptionName','newsletter','');
checkCookie('customer-subscribe','customer-subscribe','form');
checkCookie('clientFormSubmit','review-contact-form','form');
checkCookie('supportSubscription','support-contact-form','form');

function checkCookie(purpose,formName,form)
{
  var result = getCookie(purpose);
  console.log("purpose = "+purpose+" formName = "+formName+" result = "+result);
  if(result == "")
  {
    if(form == "")
    {
      jQuery("."+formName).show();
    }
    else
    {
      if(formName == 'client-page-contact-form')
      {
        console.log("inline");
        jQuery("form.client-page-contact-form").attr('style','display: blcok !important');
      }
      else
      {
        jQuery("form."+formName).show();
      }
    }
  }
  else
  {
    if(form == "")
    {
      jQuery("."+formName).hide();
    }
    else
    {
      jQuery("form."+formName).hide();
    }
  }
}

//SET COOKIE
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

//GET COOKIE
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}